// extracted by mini-css-extract-plugin
module.exports = {"page":"car-reviews-hub_page__LusFc"};